var _style, _g, _ellipse, _defs, _g2, _defs2, _g3, _defs3, _g4, _defs4, _g5, _defs5, _g6, _defs6, _g7, _defs7, _g8, _defs8, _g9, _defs9, _g10, _defs10, _g11, _defs11, _g12, _defs12, _g13, _defs13, _ellipse2, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_1_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 90 90",
    style: {
      enableBackground: "new 0 0 90 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#CC0000;}\n\t.st1{display:none;}\n\t.st2{display:inline;fill:#FFFFFF;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{clip-path:url(#SVGID_2_);}\n\t.st5{fill:#FFFFFF;stroke:#636466;stroke-width:0.6654;stroke-miterlimit:10;}\n\t.st6{fill:none;stroke:#636466;stroke-width:0.4491;stroke-miterlimit:10;}\n\t.st7{clip-path:url(#SVGID_4_);}\n\t.st8{clip-path:url(#SVGID_6_);}\n\t.st9{clip-path:url(#SVGID_8_);}\n\t.st10{clip-path:url(#SVGID_10_);}\n\t.st11{clip-path:url(#SVGID_12_);}\n\t.st12{fill:#636466;}\n\t.st13{clip-path:url(#SVGID_14_);}\n\t.st14{clip-path:url(#SVGID_16_);}\n\t.st15{clip-path:url(#SVGID_18_);}\n\t.st16{clip-path:url(#SVGID_20_);}\n\t.st17{clip-path:url(#SVGID_22_);}\n\t.st18{clip-path:url(#SVGID_24_);}\n\t.st19{fill:#FFFFFF;stroke:#636466;stroke-width:0.693;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st20{fill:none;stroke:#636466;stroke-width:0.6971;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st21{clip-path:url(#SVGID_26_);fill:#FFFFFF;stroke:#636466;stroke-width:0.84;stroke-miterlimit:10;}\n\t.st22{fill:none;stroke:#808285;stroke-width:0.79;}\n\t.st23{display:none;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Outter_Ring_2_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 45.2,
    cy: 44.9,
    r: 44.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "extra_small_uses_2_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M45.2,1.7c23.8,0,43.1,19.3,43.1,43.1C88.3,68.7,69,88,45.2,88S2,68.7,2,44.9C2,21.1,21.4,1.7,45.2,1.7  M45.2,1.2C21.1,1.2,1.5,20.8,1.5,44.9s19.6,43.7,43.7,43.7S88.9,69,88.9,44.9S69.3,1.2,45.2,1.2L45.2,1.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Thicker_White_border_2_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M45.2,2.2c23.6,0,42.7,19.1,42.7,42.7c0,23.6-19.1,42.7-42.7,42.7c-23.6,0-42.7-19.1-42.7-42.7 C2.5,21.3,21.6,2.2,45.2,2.2 M45.2,1.2C21.1,1.2,1.5,20.8,1.5,44.9c0,24.1,19.6,43.7,43.7,43.7c24.1,0,43.7-19.6,43.7-43.7 C88.9,20.8,69.3,1.2,45.2,1.2L45.2,1.2z"
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "CENTER_RING_FILL_2_",
    transform: "matrix(0.1602 -0.9871 0.9871 0.1602 -6.361 82.3076)",
    className: "st3",
    cx: 45.2,
    cy: 44.9,
    rx: 30.5,
    ry: 30.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "SVGID_1_",
    transform: "matrix(0.1735 -0.9848 0.9848 0.1735 -6.8617 81.6077)",
    cx: 45.2,
    cy: 44.9,
    rx: 31,
    ry: 31
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Center_Organic_rev_2_",
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M45,65.2c0,0-2.7-4.9-3.1-10.1c-0.3-3.7,1.5-6.5,1.7-9.3c0.3-4.1-3.4-6.3-0.6-18.7l6.4-0.2 c0,0-1.1,6-1.7,9.2c-0.8,4.5,1.4,7.6,1.7,10.7c0.4,3.9-3.9,4.1-4.7,7.9C44.1,57.7,44.5,62.2,45,65.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M45.3,26.8c0,0-0.1,3.7-0.5,7.9c-0.4,3.9,1.4,8.5,1.3,11.4c-0.1,2.6-1.8,3.7-2.4,7.1 c-0.6,3.6,0.4,9.1,1.2,11.1"
  })))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "SVGID_3_",
    transform: "matrix(0.1735 -0.9848 0.9848 0.1735 -6.8617 81.6077)",
    cx: 45.2,
    cy: 44.9,
    rx: 31,
    ry: 31
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "_x34__pm_oragnic_rev_2_",
    className: "st7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M73.6,57.9c0,0-0.5-3.5-1.7-7.2c-0.4-1.3-1-3.6-2.1-5.2c-1.8-2.7-6.5-5.6-8.1-8.5c-1.7-3.1-2.2-7.5-7.6-13.6 l-5.5,3.7c0,0,3.5,3,5.2,5.3c2.1,2.7,2.6,6.5,4.7,8.6c4.2,4.3,6.3,3.5,8.9,5.9C69.9,49.2,72.3,55.1,73.6,57.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M51.6,25.9c0,0,3.7,2.5,5.3,6.1c1.3,2.9,2.1,6.2,4.4,8.3c2.2,1.9,5,3.8,7,5.6c2.1,1.9,4.2,8.5,4.9,10.6"
  })))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "SVGID_5_",
    transform: "matrix(0.1735 -0.9848 0.9848 0.1735 -6.8617 81.6077)",
    cx: 45.2,
    cy: 44.9,
    rx: 31,
    ry: 31
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "_x37__pm_oragnic_rev_2_",
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M16.7,57.9c0,0,0.5-3.5,1.7-7.2c0.4-1.3,1-3.6,2.1-5.2c1.8-2.7,6.5-5.6,8.1-8.5c1.7-3.1,2.2-7.5,7.6-13.6 l5.5,3.7c0,0-3.5,3-5.2,5.3c-2.1,2.7-2.6,6.5-4.7,8.6c-4.2,4.3-6.3,3.5-8.9,5.9C20.4,49.2,18.1,55.1,16.7,57.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M38.8,25.9c0,0-3.7,2.5-5.3,6.1c-1.3,2.9-2.1,6.2-4.4,8.3c-2.2,1.9-5,3.8-7,5.6c-2.1,1.9-4.2,8.5-4.9,10.6"
  })))), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "SVGID_7_",
    transform: "matrix(0.1735 -0.9848 0.9848 0.1735 -6.8617 81.6077)",
    cx: 45.2,
    cy: 44.9,
    rx: 31,
    ry: 31
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Upper_Left_organic_2_",
    className: "st9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M0.9,29.7c0,0,2.9-3.4,7.7-5.3c3.5-1.4,8.4-0.3,11.5-1.5c3.3-1.3,7.1-5.3,15.1-6.6l1.6,5.7 c0,0-3.1,0.6-5.8,1.3c-3.4,0.9-4.9,2.2-7.9,2.7c-3.9,0.7-9.5,0.8-13.4,1.1C6.8,27.4,3.6,28.4,0.9,29.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M36.4,19.8c0,0-2.9,0-6.8,1.6c-4.2,1.7-7.4,3.2-10.3,3.9c-2.6,0.6-5.1-0.2-8.5,0.2c-3.6,0.4-8.6,3-10.3,4.3"
  })))), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "SVGID_9_",
    transform: "matrix(0.1735 -0.9848 0.9848 0.1735 -6.8617 81.6077)",
    cx: 45.2,
    cy: 44.9,
    rx: 31,
    ry: 31
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Upper_Right_organic_2_",
    className: "st10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M89.5,29.7c0,0-2.9-3.4-7.7-5.3c-3.5-1.4-8.4-0.3-11.5-1.5c-3.3-1.3-7.1-5.3-15.1-6.6L53.5,22 c0,0,3.1,0.6,5.8,1.3c3.4,0.9,4.9,2.2,7.9,2.7c3.9,0.7,9.5,0.8,13.4,1.1C83.7,27.4,86.8,28.4,89.5,29.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M54.1,19.8c0,0,2.9,0,6.8,1.6c4.2,1.7,7.4,3.2,10.3,3.9c2.6,0.6,5.1-0.2,8.5,0.2c3.6,0.4,8.6,3,10.3,4.3"
  })))), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "SVGID_11_",
    transform: "matrix(0.1735 -0.9848 0.9848 0.1735 -6.8617 81.6077)",
    cx: 45.2,
    cy: 44.9,
    rx: 31,
    ry: 31
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    style: {
      overflow: "visible"
    }
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "76.3,40.8 54.8,21.1 51.1,26  "
  })))), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "SVGID_13_",
    transform: "matrix(0.1735 -0.9848 0.9848 0.1735 -6.8617 81.6077)",
    cx: 45.2,
    cy: 44.9,
    rx: 31,
    ry: 31
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    style: {
      overflow: "visible"
    }
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "57.3,55.4 50.8,23.9 44.4,25.9  "
  })))), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "SVGID_15_",
    transform: "matrix(0.1735 -0.9848 0.9848 0.1735 -6.8617 81.6077)",
    cx: 45.2,
    cy: 44.9,
    rx: 31,
    ry: 31
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    style: {
      overflow: "visible"
    }
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "33.1,55.4 39.6,23.9 46,26  "
  })))), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "SVGID_17_",
    transform: "matrix(0.1735 -0.9848 0.9848 0.1735 -6.8617 81.6077)",
    cx: 45.2,
    cy: 44.9,
    rx: 31,
    ry: 31
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    style: {
      overflow: "visible"
    }
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "14.1,40.8 35.7,21.1 39.3,26  "
  })))), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "SVGID_19_",
    transform: "matrix(0.1735 -0.9848 0.9848 0.1735 -6.8617 81.6077)",
    cx: 45.2,
    cy: 44.9,
    rx: 31,
    ry: 31
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_19_",
    style: {
      overflow: "visible"
    }
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Upper_R_spike_2_",
    className: "st16"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "83.5,16.5 83.5,16.5 83.5,16.5 54.9,15.5 55.2,21.2  "
  })))), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "SVGID_21_",
    transform: "matrix(0.1735 -0.9848 0.9848 0.1735 -6.8617 81.6077)",
    cx: 45.2,
    cy: 44.9,
    rx: 31,
    ry: 31
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_22_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_21_",
    style: {
      overflow: "visible"
    }
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Upper_L_Spike_2_",
    className: "st17"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "7,16.4 7,16.4 7,16.4 35.6,15.4 35.3,21.1  "
  })))), /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "SVGID_23_",
    transform: "matrix(0.1735 -0.9848 0.9848 0.1735 -6.8617 81.6077)",
    cx: 45.2,
    cy: 44.9,
    rx: 31,
    ry: 31
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_24_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_23_",
    style: {
      overflow: "visible"
    }
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M45.2,71.5H43c0,0-0.8-0.1-0.8-0.8c0-0.4,0.2-0.5,0.2-0.5l-12.8,1.2l-2.3-1.5V47.1c0,0,35.7,0,35.7,0v22.8 l-2.3,1.5L48,70.2c0,0,0.2,0.1,0.2,0.5c0,0.8-0.8,0.8-0.8,0.8H45.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SM_bottom_page_2_",
    className: "st19",
    d: "M45.2,69.5c0,0-2.2-1.3-5.4-1.3c-3.2,0-4.5,1.5-7.8,1.5c-3,0-3.5-0.6-3.5-0.6 c0,0,0-23.2,0-23.2s0.2,0.2,1,0.4h31.4c0.8-0.2,1-0.4,1-0.4s0,23.2,0,23.2c0,0-0.5,0.6-3.5,0.6c-3.3,0-4.6-1.5-7.8-1.5 C47.4,68.2,45.2,69.5,45.2,69.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SM_top_page_2_",
    className: "st19",
    d: "M45.2,67.1c0,0,2.2-1.3,5.2-1.3c3.1,0,4.2,1.4,6.7,1.4c2.6,0,2.9-0.6,2.9-0.6 c0,0,0-23.2,0-23.2S59.5,44,56.9,44c-2.9,0-3.8-1.5-6.9-1.5c-2.9,0-4.8,1.3-4.8,1.3s-1.9-1.3-4.8-1.3c-3.1,0-4,1.5-6.9,1.5 c-2.6,0-3.1-0.6-3.1-0.6s0,23.2,0,23.2c0,0,0.2,0.6,2.9,0.6c2.5,0,3.6-1.4,6.7-1.4C43,65.8,45.2,67.1,45.2,67.1z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "SM_spine_2_",
    className: "st20",
    x1: 45.2,
    y1: 67.1,
    x2: 45.2,
    y2: 69.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M38.8,47.4c0,0.2,0.1,0.9,0.1,1.5l-0.4,0c-0.1-0.5-0.3-0.7-0.4-0.9c-0.2-0.2-0.6-0.2-1.3-0.2h-0.6 c-0.5,0-0.5,0-0.5,0.4v2.2h1.2c1,0,1-0.1,1.2-0.8h0.4v2h-0.4c-0.1-0.7-0.1-0.8-1.2-0.8h-1.2v1.5c0,1.1,0.1,1.1,1.2,1.2v0.3h-3.5 v-0.3c0.9-0.1,1-0.1,1-1.2v-3.5c0-1.1-0.1-1.1-1-1.2v-0.3C33.4,47.4,38.8,47.4,38.8,47.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M43.1,47.4v0.3c-0.9,0.1-1,0.1-1,1.2v3.5c0,1.1,0.1,1.1,1,1.2v0.3h-3.4v-0.3c0.9-0.1,1-0.1,1-1.2v-3.5 c0-1.1-0.1-1.1-1-1.2v-0.3H43.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M47.7,47.3l0.8,1.8c0.5,1.2,1.1,2.4,1.5,3.4c0.4,0.9,0.6,1,1.3,1v0.3h-3.1v-0.3l0.3,0 c0.5-0.1,0.5-0.2,0.3-0.5c-0.1-0.3-0.4-0.9-0.7-1.4h-2.2c-0.2,0.3-0.4,0.9-0.5,1.3c-0.2,0.5-0.1,0.7,0.4,0.7l0.3,0v0.3h-2.6 v-0.3c0.7-0.1,0.9-0.1,1.3-1l2.4-5.1L47.7,47.3z M46.1,51.1H48L47,48.9h0L46.1,51.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M50.6,48.9c0-0.7,0.1-1.3,0.1-1.8H51c0.2,0.2,0.3,0.3,0.6,0.3h4.9c0.3,0,0.4-0.1,0.6-0.3h0.2 c0,0.4,0.1,1.2,0.1,1.8l-0.4,0c-0.1-0.5-0.3-0.8-0.4-0.9c-0.2-0.2-0.6-0.2-1.3-0.2h-0.6v4.6c0,1.1,0.1,1.1,1.2,1.2v0.3h-3.7 v-0.3c1-0.1,1.1-0.1,1.1-1.2v-4.6h-0.4c-1,0-1.3,0.1-1.5,0.3c-0.1,0.1-0.3,0.4-0.4,0.9C51,48.9,50.6,48.9,50.6,48.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M37.6,56.1v0.3c-0.9,0.1-1,0.1-1,1.2v3.4c0,0.6,0.1,0.9,0.3,1s0.6,0.1,1,0.1c0.5,0,1.1,0,1.4-0.3 c0.2-0.2,0.4-0.5,0.6-1l0.4,0.1c-0.1,0.3-0.3,1.3-0.4,1.6h-5.6v-0.3c1-0.1,1.1-0.1,1.1-1.2v-3.5c0-1.1-0.1-1.1-1-1.2v-0.3H37.6z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M43.3,56.1v0.3c-0.9,0.1-1,0.1-1,1.2v2.1c0,1.6,0.6,2.5,2,2.5c1.4,0,2.1-0.9,2.1-2.6v-0.6 c0-1.1-0.1-1.7-0.1-2c-0.1-0.4-0.4-0.5-1.2-0.5v-0.3h2.9v0.3c-0.6,0-0.9,0.2-1,0.5c0,0.3-0.1,0.9-0.1,2v0.7c0,1-0.2,1.8-0.9,2.4 c-0.5,0.5-1.4,0.7-2.2,0.7c-0.7,0-1.5-0.1-2.1-0.5C41.2,61.8,41,61,41,59.9v-2.3c0-1.1-0.1-1.1-1-1.2v-0.3H43.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M52.1,56.1v0.3l-0.4,0c-0.4,0-0.5,0.1-0.3,0.4c0.1,0.1,0.7,1,1.3,1.7c0.4-0.5,0.9-1.1,1.2-1.6 c0.2-0.3,0.2-0.4-0.2-0.4l-0.4,0v-0.3H56v0.3c-0.8,0.1-0.9,0.1-1.5,0.7c-0.4,0.4-0.9,1-1.5,1.8l2,2.6c0.5,0.7,0.7,0.7,1.5,0.8 v0.3h-3.4v-0.3l0.3,0c0.5,0,0.5-0.2,0.3-0.4c-0.1-0.2-0.5-0.7-1.5-2c-0.6,0.8-1.2,1.7-1.4,1.9c-0.2,0.2-0.2,0.5,0.2,0.5l0.5,0 v0.3h-2.9v-0.3c0.7-0.1,1-0.1,1.3-0.5c0.2-0.2,1.3-1.5,2-2.4l-1.7-2.2c-0.5-0.6-0.6-0.7-1.4-0.8v-0.3H52.1z"
  }))))), /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "SVGID_25_",
    transform: "matrix(0.1735 -0.9848 0.9848 0.1735 -6.8617 81.6077)",
    cx: 45.2,
    cy: 44.9,
    rx: 31,
    ry: 31
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_26_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_25_",
    style: {
      overflow: "visible"
    }
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "new_sun_2_x25__wider_2_",
    className: "st21",
    cx: 45.2,
    cy: 17.4,
    rx: 11.6,
    ry: 10
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Center_Ring_RED_2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    id: "CENTER_RING_non_Organic_2_",
    className: "st22",
    cx: 45.2,
    cy: 44.9,
    r: 30.9
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Clark_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M6.8,42.9c-1.2,0.4-1.5,1.2-1.5,2.3c0.1,2,1.5,2.8,3.1,2.8c2-0.1,3.2-1.3,3.2-3c0-1.3-0.6-1.9-1.8-2.5L9.8,42 c0.6,0.1,1.4,0.4,1.8,0.6C11.7,43,12,44.1,12,45c0.1,3.4-1.6,4.8-3.4,4.9C6.6,49.9,4.9,48,4.8,45c0-1.1,0.1-1.9,0.2-2.3 c0.6-0.1,1-0.2,1.7-0.3L6.8,42.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M10.7,38c0.8,0.2,1,0.2,1.1-0.1c0.1-0.2,0.2-0.5,0.3-0.9c0.1-0.5,0.2-1.1,0-1.4c-0.2-0.2-0.4-0.5-0.9-0.8 l0.2-0.4c0.4,0.2,1.4,0.6,1.7,0.8L11.8,41L11.4,41c0.2-1,0.1-1.2-1-1.4l-3.6-0.8c-1.1-0.2-1.2-0.2-1.5,0.8L5,39.5l0.8-3.7l0.3,0.1 c-0.1,1-0.1,1.1,1,1.3L10.7,38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M15.1,29.7l0.1-0.3c0.2-0.4,0.1-0.6-0.4-0.6c-0.4,0-1,0-1.4,0l-1,2c0.2,0.3,0.6,0.6,0.9,1 c0.4,0.4,0.5,0.4,0.8-0.1l0.2-0.3l0.3,0.1l-1.2,2.6L13,34c0.3-0.7,0.3-0.9-0.4-1.7l-3.8-4.7L8.9,27l2.1,0.1 c1.4,0.1,2.8,0.1,3.9,0.1c1.1,0,1.2-0.1,1.6-0.7l0.3,0.1l-1.5,3.1L15.1,29.7z M11.9,30.4l0.8-1.7l-2.4-0.1l0,0L11.9,30.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M17.6,23.2c0.9,0.7,1,0.7,1.7,0l0.3,0.2l-2.4,2.8L16.8,26c0.6-0.8,0.6-0.9-0.3-1.6l-2.8-2.3 c-0.9-0.7-1-0.7-1.6,0l-0.3-0.2l2.2-2.7c0.7-0.8,1.2-1.3,1.7-1.5c0.5-0.2,1.1-0.2,1.6,0.2c0.7,0.6,0.7,1.5,0.3,2.4 c0.3,0.1,1.2,0.1,1.8,0.2c0.7,0,1.2,0,1.6,0c0.3,0,0.5-0.1,0.8-0.3l0.2,0.2l-0.3,0.3c-1.1,1.1-1.5,1.3-2.3,1.3 c-0.6,0-1.3-0.1-2-0.2c-0.4-0.1-0.6,0-0.8,0.3l-0.2,0.2L17.6,23.2z M16.2,22.1l0.2-0.3c0.3-0.4,0.5-0.7,0.5-1.1 c0.1-0.6-0.2-1.1-0.6-1.4c-0.8-0.7-1.7-0.2-2.1,0.3c-0.4,0.5-0.4,0.5-0.1,0.8L16.2,22.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M23.8,17.2c0.6,0.9,0.8,0.9,1.6,0.4l0.2,0.3l-3,2.2l-0.2-0.3c0.7-0.6,0.7-0.7,0.1-1.6l-2.1-3 c-0.7-0.9-0.8-0.9-1.6-0.4l-0.2-0.3l3-2.2l0.2,0.3c-0.7,0.6-0.7,0.7-0.1,1.6l1,1.4c0.2-0.7,0.7-2.8,0.7-3.6c0.1-0.5,0-0.6-0.3-0.4 l-0.4,0.2l-0.2-0.3l2.6-1.9l0.2,0.3c-0.6,0.5-0.8,0.7-1.1,1.7c-0.3,1-0.5,1.9-0.7,2.7c1.3,0.3,2.7,0.5,4,0.7 c0.9,0.1,1.1,0.1,1.6-0.2l0.2,0.3l-2,1.5c-0.7-0.2-3-0.6-4.5-1l0,0L23.8,17.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M32.9,6.6L33,6.9c-0.9,0.3-0.9,0.4-0.6,1.5l0.6,2.1c0.5,1.6,1.4,2.3,2.7,1.9c1.4-0.4,1.8-1.6,1.3-3.3 l-0.2-0.7c-0.3-1.1-0.6-1.6-0.7-1.9c-0.2-0.3-0.5-0.4-1.3-0.2L34.7,6l3-0.9l0.1,0.3c-0.6,0.2-0.9,0.4-0.8,0.8c0,0.3,0.1,0.9,0.5,2 L37.7,9c0.3,1,0.4,1.9-0.1,2.7c-0.4,0.6-1.2,1.2-2,1.4c-0.8,0.2-1.7,0.4-2.4,0.1c-0.8-0.2-1.3-0.9-1.7-2.1l-0.7-2.3 c-0.3-1.1-0.5-1.1-1.4-0.9l-0.1-0.3L32.9,6.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M47.6,11.5l-0.8,0l-5.2-5h0l0.1,2.2c0,1.1,0.1,1.7,0.2,2c0.1,0.4,0.4,0.5,1.2,0.5l0,0.3l-3.2,0.1l0-0.3 c0.6,0,0.9-0.2,1-0.6c0-0.3,0.1-0.9,0.1-2l-0.1-2.1c0-0.7,0-0.9-0.3-1.2c-0.2-0.2-0.6-0.3-1.1-0.3l0-0.3l2.2-0.1l5.1,4.6h0 l-0.1-1.9c0-1.1-0.1-1.7-0.2-2C46.5,5.1,46.2,5,45.3,5l0-0.3l3.2-0.1l0,0.3c-0.6,0-0.9,0.2-1,0.6c0,0.3-0.1,0.9-0.1,2L47.6,11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M52.4,10.6c-0.2,1.1-0.1,1.2,0.8,1.5l-0.1,0.3l-3.7-0.7l0.1-0.3c0.9,0.1,1.1,0.1,1.3-1.1l0.7-3.6 c0.2-1.1,0.1-1.2-0.8-1.5L50.7,5l3.7,0.7L54.3,6c-0.9-0.1-1.1-0.1-1.3,1.1L52.4,10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M56.8,13.7c-0.1-2.1-0.3-5-0.4-6.1c-0.1-1.1-0.3-1.2-0.9-1.5l0.1-0.3l3.4,1.3l-0.1,0.3l-0.4-0.1 c-0.5-0.1-0.5,0-0.5,0.4c0,0.6,0.2,3,0.3,4.6c0.7-0.7,2.5-2.6,2.9-3c0.5-0.6,0.5-0.7,0-1l-0.3-0.2l0.1-0.3l2.8,1.1l-0.1,0.3 C62.8,9,62.7,9,61.8,9.8c-0.1,0.1-2.7,2.5-4.4,4.2L56.8,13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M64.3,11.2c0.6-1,0.6-1.1-0.2-1.6l0.2-0.3l4.9,3.2c-0.1,0.2-0.5,0.8-0.8,1.5l-0.4-0.2 c0.2-0.5,0.2-0.8,0.1-1.1c-0.1-0.3-0.4-0.5-1-0.9l-0.4-0.3c-0.4-0.3-0.4-0.3-0.6,0L65,13.3l0.8,0.5c0.9,0.6,1,0.6,1.5-0.1l0.4,0.2 l-1.3,2L66,15.7c0.3-0.8,0.3-0.8-0.6-1.4l-0.8-0.5l-0.9,1.4c-0.4,0.7-0.5,0.9-0.3,1.1c0.1,0.2,0.4,0.4,0.9,0.7 c0.5,0.3,1,0.6,1.4,0.5c0.3,0,0.7-0.2,1.1-0.6l0.3,0.3c-0.3,0.3-1.1,1.1-1.3,1.3l-5.3-3.4l0.2-0.3c0.9,0.5,1,0.5,1.7-0.5 L64.3,11.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M69.7,19.9c-0.8,0.8-0.8,0.9-0.2,1.6l-0.2,0.2l-2.6-2.7l0.2-0.2c0.7,0.7,0.8,0.7,1.7-0.1l2.6-2.5 c0.8-0.8,0.8-0.9,0.2-1.6l0.2-0.2l2.4,2.5c0.8,0.8,1.2,1.3,1.3,1.9c0.2,0.6,0,1.1-0.4,1.6c-0.7,0.6-1.5,0.6-2.4,0.1 c-0.1,0.3-0.3,1.2-0.4,1.8c-0.1,0.7-0.2,1.2-0.2,1.6c0,0.3,0,0.6,0.2,0.8L72,24.8l-0.3-0.3c-1-1.2-1.1-1.7-1-2.5 c0.1-0.6,0.3-1.3,0.5-1.9c0.1-0.4,0-0.6-0.2-0.8L70.7,19L69.7,19.9z M71,18.7l0.3,0.3c0.4,0.4,0.7,0.6,1,0.7 c0.6,0.1,1.1-0.1,1.4-0.4c0.8-0.7,0.4-1.6-0.1-2.1c-0.4-0.4-0.5-0.4-0.8-0.1L71,18.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M74.2,24.5c-0.4,0.5-1,1.7-0.3,2.8c0.4,0.7,1.1,0.8,1.6,0.5c0.6-0.4,0.7-1,0.5-2L76,25.5 c-0.2-1.1-0.2-2.2,0.7-2.7c1-0.6,2.3-0.2,3.3,1.3c0.2,0.3,0.4,0.7,0.5,1.1c0.1,0.2,0.1,0.4,0.2,0.5c-0.3,0.2-0.7,0.6-1.1,1 l-0.3-0.4c0.4-0.5,0.8-1.3,0.3-2.2c-0.4-0.7-1-0.8-1.6-0.5c-0.5,0.3-0.5,0.9-0.3,1.8l0.1,0.4c0.2,1.1,0.2,2.2-0.7,2.8 c-1.1,0.7-2.5,0.1-3.5-1.4c-0.2-0.4-0.4-0.8-0.5-1.2c-0.1-0.4-0.2-0.6-0.2-0.8c0.2-0.2,0.7-0.7,1.2-1.2L74.2,24.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M78.1,32.7c-1.1,0.4-1.1,0.5-0.8,1.4l-0.3,0.1l-1.4-3.5l0.3-0.1c0.4,0.9,0.5,0.9,1.6,0.5l3.4-1.4 c1.1-0.4,1.1-0.5,0.8-1.4l0.3-0.1l1.4,3.5L83,31.8c-0.4-0.9-0.5-0.9-1.6-0.5L78.1,32.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M79.8,39c-1.1,0.2-1.2,0.3-1,1.5l-0.3,0.1l-0.8-4l0.3-0.1c0.3,1.1,0.4,1.1,1.5,0.9l4.7-0.9l-0.1-0.3 c-0.2-1-0.4-1.3-0.6-1.5c-0.2-0.1-0.5-0.2-1-0.3l-0.1-0.5c0.8-0.1,1.5-0.2,2-0.2l0,0.2c-0.2,0.3-0.2,0.4-0.1,0.7l1,5 c0.1,0.3,0.2,0.5,0.4,0.6l0,0.2c-0.4,0.1-1.2,0.3-1.9,0.5l-0.1-0.4c0.5-0.2,0.8-0.4,0.9-0.7c0.1-0.2,0.1-0.7,0-1.4l-0.1-0.5 L79.8,39z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M80,46.6c-1.1,0-1.2,0.1-1.3,1.2l-0.3,0l0.1-4.1l0.3,0c0,1.1,0.1,1.2,1.3,1.2l1,0c0.3,0,0.4,0,0.6-0.2 c0.6-0.3,1.3-0.8,2.5-1.6c0.8-0.5,0.8-0.6,0.9-1.3l0.3,0l-0.1,3.5l-0.3,0L84.9,45c0-0.3-0.1-0.3-0.5-0.2c-0.8,0.5-1.6,1-2.4,1.5 c0.6,0.4,1.6,1,2.3,1.4c0.4,0.2,0.5,0.2,0.5-0.3l0.1-0.5l0.3,0l-0.1,3l-0.3,0c0-0.8-0.1-0.9-0.9-1.5c-0.6-0.5-1.1-0.9-2.1-1.5 c-0.4-0.2-0.4-0.3-0.9-0.3L80,46.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Roman_Numbers_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "M_1_",
    className: "st23",
    d: "M18.2,67L18,67.2c-0.5-0.7-0.6-0.7-1.4-0.1l-2.6,1.8c-0.9,0.6-0.9,0.6-0.4,1.4l-0.3,0.2l-1.7-2.7 l0.2-0.2c0.5,0.7,0.5,0.7,1.4,0.1l2.9-1.9l0,0l-5.4,0.6L10.5,66l2.6-4.5l0,0l-2,1.2c-0.7,0.4-1.1,0.7-1.3,0.9 c-0.3,0.2-0.2,0.5,0.1,1.1l-0.2,0.2l-1.4-2.2l0.3-0.2c0.3,0.4,0.5,0.5,0.8,0.4c0.3-0.1,0.8-0.3,1.5-0.8l1.7-0.9 c1.1-0.6,1.1-0.7,0.7-1.5l0.2-0.2l1.2,1.9l-2.3,4.2l4.7-0.5L18.2,67z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "M_moved_2_",
    className: "st3",
    d: "M19.1,66.7l-0.2,0.2c-0.5-0.7-0.6-0.7-1.4-0.1l-2.6,1.8c-0.8,0.6-0.8,0.6-0.4,1.4L14.2,70 l-1.7-2.6l0.2-0.2c0.5,0.6,0.5,0.7,1.4,0.1l2.8-1.9l0,0L11.7,66l-0.2-0.3l2.5-4.4l0,0L12,62.4c-0.7,0.4-1.1,0.7-1.3,0.9 c-0.3,0.2-0.2,0.5,0.1,1.1l-0.2,0.2l-1.4-2.2l0.2-0.2c0.3,0.4,0.5,0.5,0.8,0.4c0.3-0.1,0.8-0.3,1.5-0.7l1.6-0.9 c1.1-0.6,1.1-0.7,0.7-1.5l0.2-0.2l1.2,1.8l-2.2,4.1l4.6-0.5L19.1,66.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "M_distorted_1_",
    className: "st23",
    d: "M18.2,67L18,67.2c-0.5-0.7-0.6-0.7-1.4-0.1l-2.6,1.8c-0.9,0.6-0.9,0.6-0.4,1.4l-0.3,0.2 l-1.7-2.7l0.2-0.2c0.5,0.7,0.5,0.7,1.4,0.1l2.9-1.9l0,0l-5.2,0.4l-0.2-0.3l2.6-4.5L13,61.5l-1.8,1c-0.7,0.4-1.1,0.7-1.3,0.9 c-0.3,0.2-0.2,0.5,0.1,1.1l-0.2,0.2l-1.4-2.2l0.2-0.2c0.3,0.4,0.5,0.5,0.8,0.4c0.3-0.1,0.8-0.3,1.5-0.8l1.7-0.9 c1.1-0.6,1.1-0.7,0.7-1.5l0.2-0.2l1.2,1.9l-2.5,4.4l4.7-0.5L18.2,67z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "D_1_",
    className: "st23",
    d: "M21.2,69.9c0.9,0.9,1.5,1.9,1.6,2.8c0.1,0.7-0.1,1.5-0.7,2c-1.6,1.6-3.8,0.8-5.7-1.1l-2-2l0.2-0.2 c0.7,0.6,0.8,0.6,1.5-0.1l2.3-2.3c0.7-0.7,0.7-0.8,0.2-1.4l0.2-0.2L21.2,69.9z M17.3,72.4c-0.6,0.6-0.7,0.8-0.1,1.4 c1.1,1.1,2.6,1.1,3.7,0c1.4-1.4,1-2.7-0.1-3.8c-0.2-0.2-0.4-0.4-0.5-0.4c-0.1,0-0.2,0.1-0.4,0.3L17.3,72.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "D_rotated_2_",
    className: "st3",
    d: "M21.9,69.7c0.9,0.9,1.4,1.9,1.5,2.8c0,0.7-0.2,1.4-0.8,2c-1.6,1.5-3.8,0.7-5.5-1.2l-1.9-2 l0.2-0.2c0.6,0.6,0.7,0.6,1.5-0.1l2.3-2.1c0.7-0.7,0.7-0.8,0.2-1.4l0.2-0.2L21.9,69.7z M17.9,72c-0.6,0.6-0.7,0.8-0.2,1.4 c1.1,1.2,2.5,1.2,3.6,0.1c1.4-1.3,1.1-2.6,0-3.8c-0.2-0.2-0.4-0.4-0.5-0.4s-0.2,0.1-0.4,0.3L17.9,72z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C_1_",
    className: "st23",
    d: "M29.1,77.7c0.3-1.1-0.2-1.7-1-2.2c-1.5-0.9-2.8-0.2-3.5,0.9c-0.9,1.5-0.6,3,0.7,3.8 c1,0.6,1.7,0.4,2.7-0.1l0.3,0.3c-0.4,0.4-1,0.9-1.3,1.1c-0.3-0.1-1.3-0.5-1.9-0.8c-2.6-1.5-2.8-3.5-2-4.8c0.9-1.6,3.2-1.9,5.4-0.5 c0.8,0.5,1.4,1,1.6,1.2c-0.2,0.5-0.4,0.9-0.6,1.4L29.1,77.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C_rotated_2_",
    className: "st3",
    d: "M29.4,76.9c0.2-1.1-0.2-1.7-1.1-2.1c-1.5-0.8-2.8-0.1-3.4,1.1c-0.8,1.5-0.5,3,0.8,3.7 c1,0.5,1.7,0.4,2.7-0.2l0.3,0.2c-0.4,0.4-0.9,0.9-1.2,1.1c-0.3-0.1-1.3-0.4-1.9-0.8c-2.6-1.4-2.8-3.3-2.1-4.6c0.9-1.6,3-2,5.3-0.7 c0.8,0.4,1.4,1,1.6,1.2c-0.2,0.5-0.3,0.9-0.5,1.4L29.4,76.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C_2_1_",
    className: "st23",
    d: "M36,80.2c0-1.1-0.5-1.7-1.4-2c-1.6-0.6-2.8,0.4-3.3,1.6c-0.6,1.6,0,3.1,1.4,3.5 c1.1,0.4,1.8,0.1,2.6-0.7l0.4,0.2c-0.3,0.4-0.8,1-1.1,1.3c-0.3,0-1.3-0.2-2.1-0.4c-2.8-1-3.4-2.9-2.9-4.3c0.6-1.7,2.7-2.5,5.2-1.6 c0.9,0.3,1.5,0.7,1.8,0.9c-0.1,0.5-0.2,0.9-0.3,1.5L36,80.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C_2_tweeked_2_",
    className: "st3",
    d: "M36.2,79.5c0-1.1-0.6-1.6-1.5-1.9c-1.6-0.5-2.7,0.5-3.1,1.7c-0.5,1.6,0.1,3,1.5,3.4 c1,0.3,1.7,0,2.6-0.7l0.4,0.2c-0.3,0.4-0.7,1.1-1,1.3c-0.3,0-1.3-0.1-2-0.4c-2.8-0.9-3.4-2.7-3-4.1c0.5-1.7,2.6-2.5,5-1.8 c0.9,0.3,1.5,0.7,1.8,0.8c-0.1,0.5-0.1,0.9-0.3,1.5L36.2,79.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M43.6,80.6c-0.2-1.1-0.9-1.5-1.8-1.6c-1.7-0.2-2.6,0.9-2.8,2.2c-0.2,1.7,0.6,2.9,2.1,3.1 c1.1,0.1,1.7-0.3,2.4-1.2l0.4,0.1c-0.2,0.5-0.5,1.2-0.8,1.5c-0.3,0-1.3,0.1-2.1,0c-2.9-0.4-3.9-2.1-3.7-3.5 c0.2-1.8,2.1-2.9,4.6-2.6c0.9,0.1,1.6,0.4,1.9,0.5c0,0.5,0,0.9,0,1.5L43.6,80.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M47.3,83.4c0,0.7,0.1,0.9,0.3,0.9c0.2,0.1,0.5,0,0.8,0c0.4,0,0.9-0.1,1.2-0.4c0.2-0.2,0.3-0.5,0.5-0.9l0.4,0 c0,0.4-0.2,1.3-0.3,1.6l-5.2,0.3l0-0.3c0.9-0.1,1-0.2,0.9-1.2l-0.2-3.1c-0.1-1-0.1-1-1-1.1l0-0.3l3.3-0.2l0,0.3 c-0.9,0.1-0.9,0.2-0.9,1.2L47.3,83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M55.2,83.3l0.3-0.1c0.4-0.1,0.4-0.3,0.1-0.5c-0.2-0.2-0.5-0.5-1.6-1.4c-0.3,0.7-0.6,1.6-0.7,1.9 c-0.1,0.2-0.2,0.5,0.3,0.4l0.4-0.1l0.1,0.3l-2.7,0.7l-0.1-0.3c0.6-0.2,0.8-0.3,1-0.6c0.2-0.3,0.9-1.7,1.3-2.6l-2.1-1.6 C51,79,50.9,78.9,50.1,79l-0.1-0.3l3.1-0.8l0.1,0.3l-0.3,0.1c-0.3,0.1-0.4,0.2-0.2,0.3c0.1,0.1,0.8,0.7,1.4,1.2 c0.2-0.4,0.5-1.1,0.7-1.6C55,78,55,77.9,54.6,78L54.2,78l-0.1-0.3l2.5-0.6l0.1,0.3c-0.7,0.2-0.8,0.3-1.2,0.9 c-0.3,0.5-0.7,1.2-1,1.9l2.5,1.9c0.6,0.5,0.8,0.5,1.5,0.4l0.1,0.3l-3.3,0.8L55.2,83.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M62.7,80.5l0.3-0.2c0.4-0.2,0.3-0.3,0-0.5c-0.2-0.1-0.6-0.3-1.9-1c-0.2,0.8-0.3,1.7-0.3,2 c0,0.2-0.1,0.5,0.4,0.3l0.4-0.1l0.1,0.3l-2.5,1.2L59,82.3c0.5-0.3,0.7-0.5,0.9-0.8c0.1-0.3,0.5-1.8,0.8-2.8l-2.3-1.2 c-0.6-0.3-0.8-0.3-1.5-0.1l-0.1-0.3l2.9-1.4l0.1,0.3l-0.3,0.2c-0.3,0.2-0.3,0.2-0.1,0.4c0.1,0.1,1,0.6,1.7,0.9 c0.1-0.5,0.3-1.2,0.3-1.8c0-0.3,0-0.4-0.3-0.2l-0.4,0.1l-0.1-0.3l2.4-1.1l0.1,0.3c-0.6,0.4-0.7,0.5-1,1.1 c-0.2,0.5-0.4,1.3-0.6,2.1l2.8,1.4c0.7,0.3,0.8,0.3,1.5,0l0.1,0.3l-3.1,1.5L62.7,80.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M69.5,76.3l0.2-0.2c0.3-0.3,0.3-0.4-0.1-0.5c-0.2-0.1-0.7-0.2-2-0.6c0,0.8,0.1,1.7,0.1,2c0,0.2,0,0.5,0.4,0.3 l0.3-0.2l0.2,0.2L66.4,79l-0.2-0.2c0.4-0.4,0.6-0.6,0.7-1c0-0.3,0.2-1.9,0.2-2.9l-2.5-0.7c-0.7-0.2-0.8-0.2-1.4,0.2L63,74.2 l2.6-1.9l0.2,0.2l-0.3,0.2c-0.3,0.2-0.3,0.3,0,0.4c0.1,0.1,1.1,0.4,1.8,0.5c0-0.5,0-1.2,0-1.8c0-0.3,0-0.4-0.4-0.2l-0.3,0.2 l-0.2-0.2l2.1-1.6l0.2,0.2c-0.5,0.5-0.6,0.6-0.7,1.3c-0.1,0.5-0.2,1.3-0.2,2.2l3,0.8c0.7,0.2,0.9,0.1,1.5-0.3l0.2,0.2l-2.7,2 L69.5,76.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M75,71.7c-1.7-0.5-4.1-1.2-5-1.5c-0.9-0.3-1.1-0.2-1.5,0.2l-0.2-0.2l2.1-2.4l0.2,0.2l-0.2,0.3 c-0.2,0.3-0.2,0.4,0.2,0.5c0.5,0.2,2.4,0.7,3.8,1.1c-0.4-0.8-1.4-2.8-1.6-3.2c-0.3-0.6-0.4-0.6-0.8-0.3l-0.2,0.2l-0.2-0.2l1.7-1.9 l0.2,0.2c-0.4,0.6-0.4,0.7-0.1,1.6c0.1,0.1,1.2,2.9,2,4.8L75,71.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M78.2,65c0.8,0.5,0.9,0.5,1.4-0.2l0.2,0.2l-1.7,2.7l-0.2-0.2c0.4-0.7,0.4-0.8-0.5-1.4l-2.7-1.7 c-0.8-0.5-0.9-0.5-1.4,0.2l-0.2-0.2l1.7-2.7l0.2,0.2c-0.4,0.7-0.4,0.8,0.5,1.4L78.2,65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M80.2,61.2c0.9,0.4,1,0.4,1.4-0.3l0.3,0.1l-1.4,2.9l-0.3-0.1c0.3-0.8,0.3-0.9-0.6-1.3l-2.8-1.4 c-0.9-0.4-1-0.4-1.4,0.3l-0.3-0.1l1.4-2.9l0.3,0.1c-0.3,0.8-0.3,0.9,0.6,1.3L80.2,61.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Diamonds_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M10.6,57.7c-0.3-0.3-0.5-0.5-0.7-0.7c-0.2-0.2-0.4-0.3-0.5-0.4c-0.2-0.1-0.4-0.1-0.6-0.2s-0.6-0.1-1-0.1 l0-0.1c0.3-0.3,0.6-0.5,0.7-0.7s0.3-0.4,0.4-0.5C9,54.8,9,54.6,9.1,54.4c0.1-0.2,0.1-0.6,0.1-1l0.1,0c0.3,0.3,0.5,0.6,0.7,0.7 c0.2,0.2,0.4,0.3,0.5,0.4c0.2,0.1,0.4,0.1,0.6,0.2c0.2,0,0.6,0.1,1,0.1l0,0.1c-0.3,0.3-0.6,0.5-0.7,0.7c-0.2,0.2-0.3,0.4-0.4,0.5 c-0.1,0.1-0.1,0.3-0.2,0.6s-0.1,0.6-0.1,1L10.6,57.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M81.7,52.7c0,0.4,0.1,0.7,0.1,1c0.1,0.2,0.1,0.4,0.2,0.6c0.1,0.2,0.2,0.3,0.4,0.5c0.2,0.2,0.4,0.4,0.7,0.7 l0,0.1c-0.4,0-0.7,0.1-1,0.2s-0.4,0.1-0.6,0.2c-0.1,0.1-0.3,0.2-0.5,0.4c-0.2,0.2-0.4,0.4-0.6,0.7l-0.1,0c0-0.4-0.1-0.7-0.1-1 c-0.1-0.2-0.1-0.4-0.2-0.6c-0.1-0.1-0.2-0.3-0.4-0.5c-0.2-0.2-0.4-0.4-0.7-0.7l0-0.1c0.4,0,0.7-0.1,1-0.2c0.2-0.1,0.4-0.1,0.6-0.2 c0.1-0.1,0.3-0.2,0.5-0.4c0.2-0.2,0.4-0.4,0.6-0.7L81.7,52.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.cc4cd06f831a420af7683b3dad33f536.svg";
export { ForwardRef as ReactComponent };